<template>
  <div class="equipment-detail-container">
    <div class="equipment-detail">
      <div class="jc-page-header">
        <h1>
          <a href="javascript:void(0)" @click="jump_to_up()">
            <i class="el-icon-arrow-left"></i>
          </a>{{ $t('equipment.equipmentDetail') }}
          <small>{{equipmentSn}}</small>
        </h1>
      </div>

      <div class="jc-page-content">
        <div class="el-tabs el-tabs--border-card">
          <div class="el-tabs__content">
            <div class="el-section">
              <div class="el-section-header">
                <h3 class="el-section-title">{{$t('merge.basicInfo')}}</h3>
              </div>
              <div class="el-section-content">
                <div class="base-info">
                  <!-- 基本信息  -->
                  <div class="base-info-item">
                    <div class="item" :title="equipmentDetailTable.deviceNo">{{$t('equipment.equipmentNumber') + '(ID)'}}：{{equipmentDetailTable.deviceNo != ""?equipmentDetailTable.deviceNo : '--'}}</div>
                    <div class="item">{{$t('equipment.snNumber')}}：{{equipmentDetailTable.snNo != ""?equipmentDetailTable.snNo : '--'}}</div>
                    <div class="item">{{$t('cabinet.cabinetNumCode')}}：{{equipmentDetailTable.cabinetNo != ""?equipmentDetailTable.cabinetNo : '--'}}</div>
                  </div>
                  <div class="base-info-item">
                    <div class="item">{{$t('equipment.locateUbit')}}：{{equipmentDetailTable.rackUIndex != ""?equipmentDetailTable.rackUIndex : '--'}}</div>
                    <div class="item">{{$t('equipment.uNo')}}：{{equipmentDetailTable.uNum != ""?equipmentDetailTable.uNum : '--'}}</div>
                    <div class="item">{{$t('text.brand')}}：{{equipmentDetailTable.brand != ""?equipmentDetailTable.brand : '--'}}</div>
                  </div>
                  <div class="base-info-item">
                    <div class="item">{{$t('text.model')}}：{{equipmentDetailTable.model != ""?equipmentDetailTable.model : '--'}}</div>
                    <div class="item">
                      {{ $t('equipment.systemIp') }}: {{ equipmentDetailTable.sysIp | maybeEmpty }}
                    </div>
                    <div class="item">
                      {{ $t('equipment.manageIp') }}: {{equipmentDetailTable.manageIp | maybeEmpty}}
                    </div>
                  </div>
                  <div class="base-info-item">
                    <div class="item">{{$t('equipment.equipmentType')}}：{{equipmentDetailTable.deviceTypeName != ""?equipmentDetailTable.deviceTypeName : '--'}}</div>
                    <div class="item">{{$t('equipment.equipmentStatus')}}：{{equipmentDetailTable.assetStatusName != ""?equipmentDetailTable.assetStatusName : '--'}}</div>
                    <div class="item">{{$t('text.tags')}}：{{equipmentDetailTable.tagPairs != ""?equipmentDetailTable.tagPairs : '--'}}
                    <el-button type="text"
                              @click="clickOperateTag"
                              :title="$t('text.edit')">
                        <i class="el-icon-edit"></i>
                      </el-button></div>
                    </div>
                </div>
              </div>
            </div>

            <div class="el-section">
              <div class="el-section-header">
                <h3 class="el-section-title">{{$t('equipment.belongInfo')}}</h3>
              </div>
              <div class="el-section-content">
                <div class="base-info">
                 <div :class="equipmentDetailTable.assetBelong == 2 ? 'base-info-item': 'base-info-item-spec'">
                    <div class="item">{{$t('merge.roomName')}}：{{equipmentDetailTable.idcName != ""?equipmentDetailTable.idcName : '--'}}</div>
                    <div :class="equipmentDetailTable.assetBelong == 2 ? 'item': 'item-spec'">{{$t('equipment.assetBelonging')}}：{{equipmentDetailTable.assetBelongName != ""?equipmentDetailTable.assetBelongName : '--'}}</div>
                    <div class="item" v-if="equipmentDetailTable.assetBelong == 2">{{$t('cabinet.EnablingTime')}}：{{equipmentDetailTable.deviceOpenTime | maybeEmpty}}</div>
                  </div>
                  <div class="base-info-item" v-if="equipmentDetailTable.assetBelong == 2">
                    <!--<div class="item" v-if="equipmentDetailTable.assetBelong == 2">{{$t('cabinet.rentingTime')}}：{{equipmentDetailTable.startTime != ""?equipmentDetailTable.startTime : '&#45;&#45;'}}</div>-->
                    <!--<div class="item" v-if="equipmentDetailTable.assetBelong == 2">{{$t('cabinet.expireTime')}}：{{equipmentDetailTable.endTime != ""?equipmentDetailTable.endTime : '&#45;&#45;'}}</div>-->
                    <div class="item"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="el-section">
              <div class="el-section-header">
                <h3 class="el-section-title">{{$t('equipment.configInfo')}}</h3>
              </div>
              <div class="el-section-content">
                <div class="base-info">
                  <!-- 创建时间  -->
                  <div class="base-info-item">
                    <div class="item">{{$t('equipment.cpu')}}：{{equipmentDetailTable.cpuCore | maybeEmpty}}</div>
                    <div class="item">{{$t('equipment.memory')}}：{{equipmentDetailTable.memory | maybeEmpty}}</div>
                    <div class="item">{{$t('equipment.disk')}}：{{equipmentDetailTable.disk | maybeEmpty}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--编辑标签-->
    <jcb-tag-edit :visible.sync="editTagDialogVisible"
                  :service-code="ServiceCodeConstant.CCS"
                  :region-id="TagRegionID"
                  :resource-ids="resourceId"
                  @complete="getEquipmentInfoBySn">
    </jcb-tag-edit>
    </div>
  </div>
</template>

<script>
import { ServiceCodeConstant } from '@/common/Constants';

export default {
  data() {
    return {
      equipmentSn: '',
      idcId: '',
      deviceId: '',
      equipmentDetailTable: [],
      equipmentTypeMap: {
        server: '服务器',
        net: '网络设备',
        storage: '存储设备',
        other: '其他设备'
      },
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      resourceId: []
    };
  },
  methods: {
    clickOperateTag () {
      this.resourceId = [].concat([this.equipmentDetailTable.deviceId]);
      this.editTagDialogVisible = true;
    },
    jump_to_up() {
      this.$router.push({
        name: 'EquipmentList',
      });
    },
    getEquipmentInfoBySn() {
      const target = this;
      target.$api.getEquipmentInfoBySn({ idc: target.idcId, deviceId: target.deviceId }).then((response) => {
        target.equipmentDetailTable = response.data.device;
        // 格式化标签键值对
        const tagPairs = response.data.device.tags;
        this.equipmentDetailTable.tagPairs = '';
        if (tagPairs !== undefined) {
          if (tagPairs.length > 0) {
            tagPairs.forEach((tag) => {
              this.equipmentDetailTable.tagPairs += `${tag.key}:${tag.value},`;
            });
            this.equipmentDetailTable.tagPairs = this.equipmentDetailTable.tagPairs.substring(0, this.equipmentDetailTable.tagPairs.length - 1);
          }
        }
        target.equipmentDetailTable.equipmentTypeName = target.equipmentTypeMap[target.equipmentDetailTable.equipmentType];
        target.equipmentSn = target.equipmentDetailTable.snNo;
      });
    }
  },
  mounted() {
    this.idcId = this.$route.query.idcId;
    this.deviceId = this.$route.query.deviceId;
    this.getEquipmentInfoBySn();
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
  },
};
</script>

<style lang="scss">
.equipment-detail-container {
  /* // 设置footer分页(勿动) */
  background-color: #ebf1f6;
  height: 100%;
  width: 100%;
  overflow: auto;

  .el-section+.el-section {
      border-top: 1px dotted #d9e1e9;
      padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Equipment/EquipmentDetail.vue